import dayjs from "dayjs";

export default {
  items: {},
  toBePlannedEvents: [],
  timeSlots: [],
  eventFilters: {},
  eventSearch: undefined,
  eventAgendaFilters: [],
  eventTypes: undefined,
  eventTypesGroup: undefined,
  loadedHolidayYears: [],
  holidays: [],
  selectedTimeSlot: null,
  selectedCalendarEvent: null,
  blockTimeSlotEdition: false,
  customer: {
    roles: [],
  },
  security: {
    token: localStorage.getItem("user-token") || undefined,
    refreshToken: localStorage.getItem("refresh-token") || undefined,
    expireAt: localStorage.getItem("expire-at-token") || undefined,
  },
  credits: [],
  status: "",
  hasLoadedOnce: false,
  loading: true,
  impersonate: JSON.parse(localStorage.getItem("impersonate")) || undefined,
  notificationCount: 0,
  notifications: [],
  calendarOwner: undefined,
  calendarOwners: [],
  restWorkTime: undefined,
  replaceSubtype: false,
  supervisionFiltersEnabled:
    JSON.parse(localStorage.getItem("supervision-filters-enabled")) || {},
  departments: [],
  businessGroups: [],
  eventRules: [],
  calendarDate: dayjs().format("YYYY-MM-DD"),
  impersonationRedirectPath: null,
};
